/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-observers */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { isEmpty } from '@ember/utils';
import { service } from '@ember/service';
import { observes } from '@ember-decorators/object';

export default class XeroConnectController extends Controller {
  queryParams = ['code', 'scope', 'state', 'error'];

  // Services
  @service
  options;

  @service
  session;

  @service
  store;

  // State
  code = '';

  error = '';
  @tracked
  connected = false;
  @tracked
  connectionInProgress = true;

  @observes('code')
  _triggerConnection() {
    this.set('code', this.code);
    if (!isEmpty(this.state) && !isEmpty(this.code)) {
      this.connect();
    }
  }

  @observes('error')
  _triggerErrorHandling() {
    if (!isEmpty(this.error)) {
      this.connectionInProgress = false;
    }
  }

  connect() {
    this.connectionInProgress = true;
    this.store
      .createRecord('xero/connection', {
        schoolId: this.session.school,
        authorizationCode: this.code,
      })
      .save()
      .then(
        () => {
          this.connected = true;
          this.connectionInProgress = false;
        },
        () => {
          this.connected = false;
          this.connectionInProgress = false;
        },
      );
  }
}
